/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_External_PrivateInputs */

const cs_calendar_external_private = /** @type {(inputs: Calendar_External_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromé`)
};

const en_calendar_external_private = /** @type {(inputs: Calendar_External_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {Calendar_External_PrivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_external_private = /** @type {((inputs?: Calendar_External_PrivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_External_PrivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_external_private(inputs)
	return cs_calendar_external_private(inputs)
});